import React from 'react';
import { useTranslation } from 'react-i18next';
import {PreferenceWhen} from "../../services/preferenceTypes";
import { Select } from '@chapche/ui';

const PreferenceStructureWhen = ({ itemSaveService }) => {
    const { i18n } = useTranslation();
    const updatePreferenceValue = (value) => {
        itemSaveService.updatePreferenceProperty('when', value);
    };
    const createListOfOptions = () => {
        return Object.values(PreferenceWhen).map((it) => {
            return {
                value: it,
                label: i18n.t(`preference.scheme.when.${it}`),
            }
        })
    };
    return (
        <label className="block__text preference__form-label">
            <span>{i18n.t('app.page.preference.addTitles.when')}</span>
            <Select
                fullWidth
                className="mt-0"
                value={itemSaveService.getPreference().when}
                options={createListOfOptions()}
                onChange={updatePreferenceValue}
            />
        </label>
    );
};

export default PreferenceStructureWhen;
